<template>
  <div class="b-content">
    <div class="swiper" :style="{height: bannerHeight}">
      <el-carousel :height="bannerHeight" class="pointer" :interval="5000" arrow="never">
        <el-carousel-item v-for="(item,index) in bannerData" :key="index">
          <div class="swiper-item" @click="goActivty(item)">
            <div class="banner-img">
              <img :src="item.$img"/>
            </div>
            <div class="titlenav">
              <div class="w-1200 content">
                {{ item.title }}
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="w-1200 comitynews">
      <div class="comitynews-l">
        <div class="comitynewsl-top" style="margin-top: 30px;">
          <div v-for="(item,index) in xieHuiDongTaiBtn"
               :class="item.myclass"
               class="comitynews-btn"
               @click="changebtn(index)"
               @mouseover="xieHuiHover(item, index)"
               @mouseleave="xieHuiLeave(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div v-show="xieHuiActive === 0">
          <div class="comitynewsl-bot">
            <div class="nonews">
              <el-link v-if="dongTaiData.length===0" type="danger" disabled>暂时没有相关内容！</el-link>
            </div>
            <ul v-loading="dongTaiLoading">
              <li v-for="(item,index) in dongTaiData" @click="goarticle(item.id)">
                            <span class="comitynewsl-box">
                                 <span class="circle"></span>
                                <span>
                                    <el-link>
                                        {{ item.title }}
                                    </el-link>
                                </span>
                            </span>
                <span style="margin-right: 5px;"><el-link>{{ item.publish_time }}</el-link></span>
              </li>
            </ul>
          </div>
        </div>
        <div v-show="xieHuiActive === 1">
          <div class="comitynewsl-bot">
            <div class="nonews">
              <el-link v-if="dongTaiData1.length===0" type="danger" disabled>暂时没有相关内容！</el-link>
            </div>
            <ul>
              <li v-for="(item,index) in dongTaiData1" @click="goarticle(item.id)">
                            <span class="comitynewsl-box">
                                 <span class="circle"></span>
                                <span>
                                    <el-link>
                                        {{ item.title }}
                                    </el-link>
                                </span>
                            </span>
                <span style="margin-right: 5px;"><el-link>{{ item.publish_time }}</el-link></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="comitynews-r" style="margin-top: 20px;">
        <div class="comitynews-r-line"></div>
        <div class="textbox">会员中心</div>
        <div class="vipbox">
          <ul>
            <li
              v-for="(item, index) in huiYuanCenter"
              @mouseover="changeStyle(item, index)"
              @mouseleave="outStyle(item, index)"
              @click="goswitch(item)"
            >
              <img :src="require(`../../assets/会员中心/icon${index + 1}_${item.no}.png`)"/>
              <span class="vipicon">{{ item.type }}</span>
            </li>
          </ul>
          <div class="vipbox-rowline"></div>
          <div class="vipbox-couline-f"></div>
          <div class="vipbox-couline-s"></div>
        </div>
      </div>
    </div>
    <div @click="goOther(advertisingSpaceAll[0].url)" class="w-1200 billboard margin-top-0" v-if="advertisingSpaceAll[0].imgpath!== ''">
      <img :src="advertisingSpaceAll[0].imgpath"/>
    </div>
    <div class="w-1200 industrynews">
      <div class="comitynewsl-top" style="margin-top: 35px;">
        <div
          v-for="(item,index) in hangYeYaoWenBtn"
          :class="item.myclass"
          class="comitynews-btn"
          @click="changeHybtn(index)"
          @mouseover="hangYeHover(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-show="hangYeActive === 0">
        <div class="industrynews-box">
          <div class="nonews">
            <el-link v-if="hangYeData.length===0" type="danger" disabled>暂时没有相关内容！</el-link>
          </div>
          <ul v-loading="hangYeLoading">
            <li v-for="(item,index) in hangYeData"
                :class="index===0?'nomargin-left':index===2?'nomargin-left':index===4?'nomargin-left':''"
                @click="goarticle(item.id)">
              <div class="leftimg">
                <img :src="item.$img"/>
              </div>
              <div class="rightcontent">
                <div class="rc-title">{{ item.title }}</div>
                <div class="rc-content" v-html="item.summary"></div>
                <div class="rc-time">{{ item.publish_time }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-show="hangYeActive === 1">
        <div class="industrynews-box">
          <div class="nonews">
            <el-link v-if="hangYeData1.length===0" type="danger" disabled>暂时没有相关内容！</el-link>
          </div>
          <ul>
            <li v-for="(item,index) in hangYeData1"
                :class="index===0?'nomargin-left':index===2?'nomargin-left':index===4?'nomargin-left':''"
                @click="goarticle(item.id)">
              <div class="leftimg">
                <img :src="item.$img"/>
              </div>
              <div class="rightcontent">
                <div class="rc-title">{{ item.title }}</div>
                <div class="rc-content" v-html="item.summary"></div>
                <div class="rc-time">{{ item.publish_time }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w-1200 billboard" @click="goOther(advertisingSpaceAll[1].url)" v-if="advertisingSpaceAll[1].imgpath!== ''">
      <img :src="advertisingSpaceAll[1].imgpath"/>
    </div>
    <div class="w-1200 partybuilding">
      <div class="partybuilding-l">
        <div class="comitynewsl-top" style="padding-left: 185px; margin-top: 30px;">
          <div
            v-for="(item,index) in xieHuiDangJianBtn"
            :class="item.myclass"
            @click="changeDjbtn(index)"
            @mouseover="dangJianHover(item, index)"
            class="comitynews-btn"
          >
            {{ item.name }}
          </div>
        </div>
        <div v-show="dangJianActive === 1">
          <div class="partybuilding-bot">
            <div style="margin-top: 20px; text-align: center;">
              <el-link v-if="dangJianData.length===0" type="danger" disabled>暂时没有相关内容！</el-link>
            </div>
            <ul>
              <li v-for="(item,index) in dangJianData" @click="goarticle(item.id)">
                            <span class="partybuilding-text">
                                  <span class="circle"></span>
                                  <el-link>{{ item.title }}</el-link>
                            </span>
                <span class="margin-right-17 partybuilding-time"><el-link>{{ item.publish_time }}</el-link></span>
              </li>
            </ul>
          </div>
        </div>
        <div v-show="dangJianActive === 0">
          <div class="partybuilding-bot">
            <div style="margin-top: 20px; text-align: center;">
              <el-link v-if="dangJianData1.length===0" type="danger" disabled>暂时没有相关内容！</el-link>
            </div>
            <ul>
              <li v-for="(item,index) in dangJianData1" @click="goarticle(item.id)">
                            <span class="partybuilding-text">
                                   <span class="circle"></span>
                                  <el-link>{{ item.title }}</el-link>
                            </span>
                <span class="margin-right-17 partybuilding-time"><el-link>{{ item.publish_time }}</el-link></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="partybuilding-r">
        <div class="comitynewsl-top padding-left-30" style="margin-top: 30px;">
          <div v-for="(item,index) in qiKanBtn" :class="item.myclass" @click="changeQKbtn(index)"
               class="comitynews-btn">{{ item.name }}
          </div>
        </div>
        <div class="partybuilding-swiper">
          <div class="swiper-box" v-show="!showCode">
            <el-carousel height="276px" :interval="5000" arrow="always" indicator-position="none">
              <el-carousel-item v-for="(item,index) in qiKanData" :key="index">
                <img class="swiper-img" :src="item.$img"/>
                <div class="ps-titlenav">
                  <div class="ps-content">
                    {{ item.sub_title }}
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="code" v-show="showCode" v-for="(item,index) in weiXinData">
            <img :src="item.$img"/>
          </div>
        </div>
      </div>
    </div>
    <div class="w-1200 billboard" @click="goOther(advertisingSpaceAll[2].url)" style="margin-top: 30px;" v-if="advertisingSpaceAll[2].imgpath!== ''">
      <img :src="advertisingSpaceAll[2].imgpath"/>
    </div>
    <div class="w-1200 comityservice">
      <div class="comitynews-r-line" style="width: 100%;margin-top: 20px;"></div>
      <div class="textbox" style="margin-left: 536px;">协会服务</div>
      <div class="comityservice-box">
        <ul>
          <li
            v-for="(item,index) in comityserviceList"
            @mouseover="xieHuiFuWuinStyle(item,index)"
            @mouseout="xieHuiFuWuioutStyle(item,index)"
            @click="goBranch(index)"
          >
            <div :class="item.myclass" class="comityservice-box-img">
              <img :src="require(`../../assets/协会服务/${index+1}_${item.no}.png`)"/>
            </div>
            {{ item.text }}
          </li>
        </ul>
      </div>
    </div>
    <div class="w-1200 billboard" @click="goOther(advertisingSpaceAll[3].url)" v-if="advertisingSpaceAll[3].imgpath!== ''">
      <img :src="advertisingSpaceAll[3].imgpath"/>
    </div>
    <div class="w-1200 footer-swiper">
      <div class="comitynews-r-line" style="width: 100%;margin-top: 0;"></div>
      <div class="textbox" style="margin-left: 536px;">会员单位</div>
      <!--<div class="footer-swiper-box">-->
      <!--<div class="arrow-left" @click="moveleft"></div>-->
      <!--<div class="arrow-right" @click="moveright"></div>-->
      <!--<div class="arrow-content">-->
      <!--<ul ref="arrswiper">-->
      <!--<li-->
      <!--v-for="(item,index) in vipunitData"-->
      <!--@mouseover="unityAnimateOver(index)"-->
      <!--@mouseout="unityAnimateOut(index)"-->
      <!--&gt;-->
      <!--<img :src="item.$img" :style="{left: item.animationImg1Left, transition: item.animationImg1Tran}"  class="animation-img1"/>-->
      <!--<img :src="item.$img1" :style="{top: item.animationImg2Top, transition: item.animationImg2Tran}"  class="animation-img2"/>-->
      <!--</li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--</div>-->
    </div>
    <div class="w-1200 myswiper">
      <myswiper
        :swiperparams="vipunitData"
        v-if="vipunitData.length > 0"
      >
      </myswiper>
    </div>
  </div>
</template>

<script>
  import api from '../../model/api'
  // import swiper from '../../components/swiper'
  import myswiper from '../../components/myswiper'
  import icon1_1 from '../../assets/会员中心/icon1_1.png'
  import icon1_2 from '../../assets/会员中心/icon1_2.png'


  export default {
    data() {
      return {
        msg: '首页',
        nowIndex: 0,
        huiYuanIndex: 0,
        xieHuiActive: 0,
        hangYeActive: 0,
        dangJianActive: 0,
        homealert: true,
        bannerHeight: '540px',
        animationImg1: false,
        animationImg1Tran: '',
        animationImg2Tran: '',
        animationImg1Height: '',
        animationImg1Left: '',
        animationImg2Top: '',
        hangYeData: [], // 行业要闻数组
        hangYeData1: [], // 行业要闻数组
        dongTaiData: [], // 协会动态数组
        dongTaiData1: [], // 协会动态数组
        dangJianData: [], // 党建数组
        dangJianData1: [], // 党建数组
        qiKanData: [], // 期刊数组
        weiXinData: [], // 微信公众号数组
        bannerData: [], // banner
        vipunitData: [], // 会员单位
        vipunitDataLength: [], // 会员单位数据长度
        advertisingSpaceAll: [
          {
            imgpath: '',
          },
          {
            imgpath: '',
          },
          {
            imgpath: '',
          },
          {
            imgpath: '',
          },
        ],
        showCode: false,
        xieHuiDongTaiBtn: [
          {
            name: '协会动态',
            myclass: 'comitynews-btn-act'
          },
          {
            name: '通知公告',
            myclass: ''
          }
        ],
        hangYeYaoWenBtn: [
          {
            name: '行业要闻',
            myclass: 'comitynews-btn-act'
          },
          {
            name: '会员动态',
            myclass: ''
          }
        ],
        xieHuiDangJianBtn: [
          {
            name: '分支机构',
            myclass: 'comitynews-btn-act'
          },
          {
            name: '党建活动',
            myclass: ''
          }
        ],
        qiKanBtn: [
          {
            name: '期刊',
            myclass: 'comitynews-btn-act'
          },
          {
            name: '公众号',
            myclass: ''
          }
        ],
        huiYuanCenter: [
          {
            type: '协会章程',
            no: '2',
            src1: require(`../../assets/会员中心/icon1_1.png`),
            src2: require(`../../assets/会员中心/icon1_2.png`),
          },
          {
            type: '会员管理',
            no: '2',
            src1: require(`../../assets/会员中心/icon2_1.png`),
            src2: require(`../../assets/会员中心/icon2_2.png`),
          },
          {
            type: '会员权益',
            no: '2',
            src1: require(`../../assets/会员中心/icon3_1.png`),
            src2: require(`../../assets/会员中心/icon3_2.png`),
          },
          {
            type: '会员风采',
            no: '2',
            src1: require(`../../assets/会员中心/icon4_1.png`),
            src2: require(`../../assets/会员中心/icon4_2.png`),
          },
          {
            type: '入会流程',
            no: '2',
            src1: require(`../../assets/会员中心/icon5_1.png`),
            src2: require(`../../assets/会员中心/icon5_2.png`),
          },
          {
            type: '申请入会',
            no: '2',
            src1: require(`../../assets/会员中心/icon6_1.png`),
            src2: require(`../../assets/会员中心/icon6_2.png`),
          },
        ],
        dongTaiLoading: false,
        hangYeLoading: false,
        hangDJLoading: false,
        QKLoading: false,
        partybuildingList: [ // 党建活动数据
          {text: '植入式广告的法律规制研究', time: '2019-04-18  10:30:00'},
          {text: '世界广告主联合会针对 Facebook/剑桥分析泄露用户', time: '2019-04-18  10:30:00'},
          {text: '植入式广告的法律规制研究', time: '2019-04-18  10:30:00'},
          {text: '世界广告主联合会针对 Facebook/剑桥分析泄露用户', time: '2019-04-18  10:30:00'},
          {text: '植入式广告的法律规制研究', time: '2019-04-18  10:30:00'},
          {text: '世界广告主联合会针对 Facebook/剑桥分析泄露用户', time: '2019-04-18  10:30:00'}
        ],
        comityserviceList: [
          {id: 1, text: '品牌建设', myclass: '', no: '2'},
          {id: 2, text: '营销传播', myclass: '', no: '2'},
          {id: 3, text: '合规咨询', myclass: '', no: '2'},
          {id: 4, text: '知识产权服务', myclass: '', no: '2'},
          {id: 5, text: '广告反欺诈', myclass: '', no: '2'},
          {id: 6, text: '标准认证', myclass: '', no: '2'},
          {id: 7, text: '教育培训', myclass: '', no: '2'},
        ]
      }
    },
    components: { // 组件
      // swiper,
      myswiper
    },
    methods: {
      goOther (url) {
        console.log(url)
        if (url) {
          window.open(url)
        }
      },
      unityAnimateOver(index) { // 移入
        this.$set(this.vipunitData[index], 'animationImg1Tran', '');
        this.$set(this.vipunitData[index], 'animationImg2Tran', '');
        this.$set(this.vipunitData[index], 'animationImg1Left', '120px');
        this.$set(this.vipunitData[index], 'animationImg2Top', '0px');
      },
      unityAnimateOut(index) { // 移除
        this.$set(this.vipunitData[index], 'animationImg1Left', '0px');
        this.$set(this.vipunitData[index], 'animationImg2Top', '120px');
        this.$set(this.vipunitData[index], 'animationImg1Tran', 'all 0.4s ease-out 0s');
        this.$set(this.vipunitData[index], 'animationImg2Tran', 'all 0.4s ease-out 0s');
      },
      goswitch(item) {
        console.log(item)
        if (item.type === '会员管理') {
          this.getVipManage();
        } else if (item.type === '申请入会') {
          window.open('http://user.zggz.org.cn/#/login', '_blank');
        } else if (item.type === '入会流程') {
          this.applyMetting();
        } else if (item.type === '协会章程') {
          this.associationCharter();
        } else if (item.type === '会员权益') {
          this.memberBenefits();
        } else {
          this.$router.push({
            name: 'news',
            query: {index: 2}
          });
          this.$store.commit('changeHomeNavValue', {
            name: '新闻动态'
          })
        }
      },
      goActivty(item) {
        if (item.url) {
          window.open(item.url, '_blank')
        }
      },
      goBranch(index) {
        this.$router.push({name: 'association', query: {index: index}}); // 跳到协会服务
      },
      goarticle(id) {
        this.$router.push({name: 'art', query: {id: id}}); // 跳到新建抢购活动
      },
      setMeg() {
        this.msg = '我是改变后的数据'
      },
      moveright() {
        if (this.nowIndex === this.vipunitDataLength - 5) {
          this.$message.error('这已经是最后一张照片，无法前进！');
        } else {
          this.nowIndex++;
          this.$refs.arrswiper.style.transform = 'translateX(-' + this.nowIndex * 201 + 'px)'
        }
      },
      moveleft() {
        if (this.nowIndex === 0) {
          this.$message.error('这已经是第一张照片，无法前进！');
        } else {
          this.nowIndex--;
          this.$refs.arrswiper.style.transform = 'translateX(-' + this.nowIndex * 201 + 'px)'
        }
      },
      // 协会动态按钮
      changebtn(index) {
        this.xieHuiDongTaiBtn[0].myclass = '';
        this.xieHuiDongTaiBtn[1].myclass = '';
        this.xieHuiDongTaiBtn[index].myclass = 'comitynews-btn-act';
        this.dongTaiLoading = true;
        this.$router.push({
          name: 'news',
          params: {
            activeVlaue:this.xieHuiDongTaiBtn[index].name
          }
        });
      },
      xieHuiHover(item, index) {
        this.xieHuiDongTaiBtn[0].myclass = '';
        this.xieHuiDongTaiBtn[1].myclass = '';
        item.myclass = 'comitynews-btn-act';
        this.xieHuiActive = index
      },
      xieHuiLeave(item, index) {
      },
      // 协会动态按钮

      //行业要闻
      changeHybtn(index) {
        this.hangYeYaoWenBtn[0].myclass = '';
        this.hangYeYaoWenBtn[1].myclass = '';
        this.hangYeYaoWenBtn[index].myclass = 'comitynews-btn-act';
        // this.hangYeLoading = true;
        // this.gethyNew(this.hangYeYaoWenBtn[index].name);
        this.$router.push({
          name: 'news',
          params: {
            activeVlaue:this.hangYeYaoWenBtn[index].name
          }
        });
      },
      hangYeHover(item, index) {
        this.hangYeYaoWenBtn[0].myclass = '';
        this.hangYeYaoWenBtn[1].myclass = '';
        item.myclass = 'comitynews-btn-act';
        this.hangYeActive = index
      },
      //行业要闻

      // 党建活动
      changeDjbtn(index) {
        this.xieHuiDangJianBtn[0].myclass = '';
        this.xieHuiDangJianBtn[1].myclass = '';
        this.xieHuiDangJianBtn[index].myclass = 'comitynews-btn-act';
        console.log(index)
        if (index === 0) {
          this.$router.push({
            name: 'branch',
          })
        } else {
          this.$router.push({
            name: 'news',
            params: {
              activeVlaue:this.xieHuiDangJianBtn[index].name
            }
          })
        }
      },
      dangJianHover(item, index) {
        this.xieHuiDangJianBtn[0].myclass = '';
        this.xieHuiDangJianBtn[1].myclass = '';
        item.myclass = 'comitynews-btn-act';
        this.dangJianActive = index
      },
      // 党建活动


      changeQKbtn(index) {
        this.qiKanBtn[0].myclass = '';
        this.qiKanBtn[1].myclass = '';
        this.qiKanBtn[index].myclass = 'comitynews-btn-act';
        this.showCode = !this.showCode;
        this.QKLoading = true;
      },
      changeStyle(item, index) {
        item.no = '1';
        // console.log(item.no);
      },
      outStyle(item, index) {
        item.no = '2';
        // console.log(item.no);
      },
      xieHuiFuWuinStyle(item, index) {
        this.comityserviceList.map(item => {
          item.no = '2'
        });
        this.comityserviceList[index].no = '1';
      },
      xieHuiFuWuioutStyle(item, index) {
        this.comityserviceList[index].no = '2';
      },
      memberBenefits() { // 获取会员权益
        let vars = {};
        vars.params = {
          sec: '会员权益',
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          console.log(data, '会员权益')
          if (data && data.data && data.data.records) {
            this.$router.push({name: 'art', query: {id: data.data.records[0].id}}); // 跳到文章详情
          }
        });
      },
      associationCharter() { // 获取协会章程
        let vars = {};
        vars.params = {
          sec: '协会章程',
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          console.log(data, '协会章程')
          if (data && data.data && data.data.records) {
            this.$router.push({name: 'art', query: {id: data.data.records[0].id}}); // 跳到文章详情
          }
        });
      },
      applyMetting() { // 获取入会流程方法
        let vars = {};
        vars.params = {
          sec: '入会流程',
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          console.log(data, '入会流程')
          if (data && data.data && data.data.records) {
            this.$router.push({name: 'art', query: {id: data.data.records[0].id}}); // 跳到文章详情
          }
        });
      },
      getVipManage() { // 获取会员管理方法
        let vars = {};
        vars.params = {
          sec: '会员管理办法',
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          console.log(data, '会员管理办法')
          if (data && data.data && data.data.records) {
            this.$router.push({name: 'art', query: {id: data.data.records[0].id}}); // 跳到文章详情
          }
        });
      },
      getDangJianNews(name) { // 获取党建内容
        let vars = {};
        vars.params = {
          sec: name,
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          // console.log(data, '党建活动')
          setTimeout(() => {
            this.hangDJLoading = false;
          }, 500);
          if (name === '党建活动') {
            if (data.data) {
              this.dangJianData = data.data.records;
              this.dangJianData.map(item => {
                // item.$img = JSON.parse(item.surface)[0].$path;
                if (item.title.length > 40) {
                  item.title = item.title.substr(0, 40) + '...';
                }
                item.publish_time = item.publish_time.substr(5, 5);
              })
            }
          } else {
            if (data.data) {
              this.dangJianData1 = data.data.records;
              this.dangJianData1.map(item => {
                // item.$img = JSON.parse(item.surface)[0].$path;
                if (item.title.length > 40) {
                  item.title = item.title.substr(0, 40) + '...';
                }
                item.publish_time = item.publish_time.substr(5, 5);
              })
            }
          }
        });
      },
      getadNew() { // 获取广告条
        let vars = {};
        vars.params = {
          sec: '广告条管理',
          page: 1,
          count: 4,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          console.log(data, '广告条管理')
          let arr = [];
          if (data.data) {
            arr = data.data.records;
            arr.map((item, index) => {
              this.advertisingSpaceAll[index].imgpath = JSON.parse(item.surface)[0].$path + '&preview=true'
              this.advertisingSpaceAll[index].url = item.content
            })
          }
        });
      },
      gethyNew(name) { // 获取行业要闻
        let vars = {};
        vars.params = {
          sec: name,
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          setTimeout(() => {
            this.hangYeLoading = false;
          }, 500)
          if (name === '行业要闻') {
            if (data.data) {
              this.hangYeData = data.data.records;
              this.hangYeData.map(item => {
                if (item.surface.length > 5) {
                  item.$img = JSON.parse(item.surface)[0].$path;
                }
                if (item.summary.length > 60) {
                  item.summary = item.summary.substr(0, 60) + '...';
                }
                if (item.title.length > 26) {
                  item.title = item.title.substring(0, 26) + '...'
                }
                item.publish_time = item.publish_time.substr(5, 5);
              })
            }
          } else {
            if (data.data) {
              this.hangYeData1 = data.data.records;
              this.hangYeData1.map(item => {
                if (item.surface.length > 5) {
                  item.$img = JSON.parse(item.surface)[0].$path;
                }
                if (item.summary.length > 60) {
                  item.summary = item.summary.substr(0, 52) + '...';
                }
                if (item.title.length > 26) {
                  item.title = item.title.substring(0, 26) + '...'
                }
                item.publish_time = item.publish_time.substr(5, 5);
              })
            }
          }
        });
      },
      getXieHuiDongTaiNew(name) { // 获取协会动态
        let vars = {};
        vars.params = {
          sec: name,
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          // console.log(data, '协会动态')
          setTimeout(() => {
            this.dongTaiLoading = false;
          }, 500)
          this.dongTaiData = [];
          if (data.data) {
            this.dongTaiData = data.data.records;
            this.dongTaiData.map(item => {
              if (item.title.length > 38) {
                item.title = item.title.substr(0, 38);
              }
              item.publish_time = item.publish_time.substr(5, 5);
            })
          }
        });
      },
      getNoticeData() { // 获取通知公告的信息
        // let vars = {};
        // vars.module = 'bsmOwmhmBanner';
        // vars.key = 'getnotification';
        // vars.paging = [];
        // vars.conds = [
        //     'status=已发布',
        //     'issyncwebsit=是'
        // ];
        // vars.dims = [];
        // api.sQuery(vars, this, data => {
        //     setTimeout(() => {
        //         this.dongTaiLoading = false;
        //     }, 500);
        //     this.dongTaiData1 = [];
        //     if (data.data) {
        //         this.dongTaiData1 = data.data;
        //         this.dongTaiData1.map(item => {
        //             item.publish_time = item.releasetime.substr(5, 5);
        //         })
        //     }
        // })
        let vars = {};
        vars.params = {
          sec: '通知公告',
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          // console.log(data, '协会动态')
          setTimeout(() => {
            this.dongTaiLoading = false;
          }, 500)
          this.dongTaiData1 = [];
          if (data.data) {
            this.dongTaiData1 = data.data.records;
            this.dongTaiData1.map(item => {
              if (item.title.length > 38) {
                item.title = item.title.substr(0, 38);
              }
              item.publish_time = item.publish_time.substr(5, 5);
            })
          }
        });
      },
      getWeiXin() { // 获取微信公众号
        let vars = {};
        vars.params = {
          sec: '微信公众号',
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          // console.log(data, '微信公众号')
          if (data.data) {
            this.weiXinData = data.data.records;
            this.weiXinData.map(item => {
              item.$img = JSON.parse(item.surface)[0].$path + '&preview=true'
            })
          }
        });
      },
      getQiKan() { // 获取期刊数据
        let vars = {};
        vars.params = {
          sec: '协会期刊',
          page: 1,
          count: 6,
          status: '已发布'
        };
        api.webget(vars, this, data => {
          // console.log(data, '期刊')
          if (data.data) {
            this.qiKanData = data.data.records;
            this.qiKanData.map(item => {
              item.$img = JSON.parse(item.surface)[0].$path + '&preview=true';
              // if (item.content.length > 34) {
              //
              // }
            })
          }
          console.log(this.qiKanData)
        });
      },
      getBannerData() { // 获取banner数据
        let vars = {};
        vars.module = 'bsmOwmhmBanner';
        vars.key = 'getbanner';
        vars.paging = [];
        vars.conds = [
          'status=已发布'
        ];
        vars.dims = [];
        api.sQuery(vars, this, data => {
          // console.log(data.data, 'banner')
          if (data.data) {
            this.bannerData = data.data;
            this.bannerData.map(item => {
              item.$img = JSON.parse(item.picture)[0].$path + '&preview=true'
            });
          }
        })
      },
      getVipUnit() {
        let vars = {};
        vars.module = 'bsmOwmhmBanner';
        vars.key = 'memberunitlog';
        vars.paging = [];
        vars.conds = [];
        vars.dims = [];
        api.sQuery(vars, this, data => {
          console.log(data, '会员单位')
          if (data.data) {
            this.vipunitData = data.data;
            this.vipunitDataLength = data.data.length;
            this.vipunitData.map(item => {
              // item.$img = JSON.parse(item.img)[0].$path + '&preview=true';
              item.$img1 = JSON.parse(item.img)[0].$path + '&preview=true';
              item.animationImg1Left = '0px';
              item.transition = '';
              item.animationImg2Top = '0px';
              item.animationImg2Tran = '';
            });
          }
        })
      },
      openFullScreen2() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          // background: 'rgba(0, 0, 0, 0.7)'
          background: 'rgba(255, 255, 255, 1)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
      },
      isPc () {
        let userAgentInfo = navigator.userAgent;
        let Agents = ["Android", "iPhone",
          "SymbianOS", "Windows Phone",
          "iPad", "iPod"];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      init() {
        this.gethyNew('行业要闻');
        this.getadNew();
        this.gethyNew('会员动态');
        this.getWeiXin();
        this.getQiKan();
        this.getBannerData();
        this.getVipUnit();
        // this.getNoticeData();
        this.getXieHuiDongTaiNew('协会动态');
        this.getNoticeData('协会动态');
        this.getDangJianNews('党建活动');
        this.getDangJianNews('分支机构');
        this.getNowWidth();
      },
      getNowWidth() {

        let multiple = 540 / 1920;

        this.bannerHeight = document.body.clientWidth * multiple + 'px';
      },
    },
    beforeCreate() { // 实例刚刚被创建
    },
    created() { //实例已经创建完成
    },
    beforeMount() { // 模板编译之前
    },
    mounted() { // 模板编译完成
      // this.$store.commit('changeLoadingStatus');
      this.init();
      // console.log(api.common.navData, 'navData')
    },
    beforeUpdate() { // 数据更新之前
    },
    updated() { // 数据更新完毕
    },
    beforeDestroy() { // 实例销毁之前
    },
    destroyed() { // 实例销毁完成
    },
    watch: {
      example: {
        handler(val) {
          if (val.example) {
          }
        },
        deep: true
      },
    }
  }
</script>

<style scoped>
  .swiper {
    width: 100%;
  }

  .swiper-item {
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .titlenav {
    width: 100%;
    height: 60px;
    background: rgba(49, 49, 49, 0.27);
    position: absolute;
    /*top: 480px;*/
    bottom: 0;
    left: 0;
  }

  .ps-titlenav {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: rgba(27, 27, 27, .76);
    position: absolute;
    top: 246px;
    left: 0;
  }

  .content {
    text-align: left;
    height: 60px;
    line-height: 60px;
    font-size: 20px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .ps-content {
    text-align: center;
    font-size: 14px;
    /*font-family:MicrosoftYaHei;*/
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 30px;
  }

  .comitynews {
    height: 430px;
    display: flex;
    flex-direction: row;
  }

  .comitynews-l {
    width: 694px;
    height: 430px;
    background-color: white;
  }

  .comitynewsl-top {
    height: 52px;
    display: flex;
    flex-direction: row;
    padding-left: 185px;
    margin-top: 20px;
  }

  .comitynews-btn {
    width: 162px;
    height: 52px;
    background-color: white;
    border: 1px solid rgba(182, 11, 13, 1);
    border-radius: 4px;
    font-size: 18px;
    /*font-family: MicrosoftYaHei;*/
    font-weight: 400;
    color: rgba(182, 11, 13, 1);
    line-height: 52px;
    cursor: pointer;
    text-align: center;
  }

  .comitynews-btn:first-child {
    border-right: none !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .comitynews-btn:last-child {
    border-left: none !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }

  .comitynews-btn-act {
    background-color: #B60B0D;
    color: white;
  }

  .circle {
    width: 7px;
    height: 7px;
    background: #B60B0D;
    /*background: rgba(244, 153, 82, 1);*/
    border-radius: 50%;
    display: block;
    margin-right: 7px;
  }

  .comitynewsl-box {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .comitynewsl-bot {
    height: 100%;
    margin-top: 13px;
  }

  .comitynewsl-bot ul li {
    height: 51px;
    display: flex;
    list-style-type: none;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px dashed rgba(220, 220, 220, 1);
  }

  .comitynews-r {
    width: 450px;
    height: 430px;
    margin-left: 51px;
  }

  .comitynews-r-line {
    width: 450px;
    border-top: 1px solid rgba(182, 11, 13, 1);
    margin-top: 42px;
  }

  .textbox {
    width: 128px;
    height: 40px;
    font-size: 28px;
    /*font-family: MicrosoftYaHei;*/
    font-weight: 400;
    margin-top: -21px;
    color: rgba(182, 11, 13, 1);
    background-color: white;
    margin-left: 162px;
    text-align: center;
  }

  .vipbox {
    width: 450px;
    height: 301px;
    background: rgba(238, 238, 238, 1);
    margin-top: 35px;
    position: relative;
  }

  .vipbox-img {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 82px;
    height: 82px;
  }

  .vipbox-img:nth-child(1) {
    background: url("../../assets/会员中心/icon1_2.png");
  }

  .vipbox ul {
    display: flex;
    flex-flow: row wrap;
  }

  .hoverImg {
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    top: 0;
    opacity: 0;
    z-index: 1;
    transition: all 0.5s ease-in;
  }

  .hoverImg:hover {
    opacity: 1;
  }

  .vipbox ul li span {
    display: block;
    margin-top: 8px;
  }

  .vipbox ul li {
    position: relative;
    width: 150px;
    height: 150px;
    overflow: hidden;
    /*background:rgba(182,11,13,1);*/
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    /*font-family: MicrosoftYaHei;*/
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    box-sizing: border-box;
    cursor: pointer;
  }

  .vipbox ul li:hover {
    background: rgba(182, 11, 13, 1);
    color: rgba(255, 255, 255, 1) !important;
    z-index: 5;
  }

  .vipbox-act {
    background: rgba(182, 11, 13, 1);
    color: rgba(255, 255, 255, 1) !important;
  }

  .vipbox-rowline {
    width: 400px;
    border-top: 1px solid rgba(210, 210, 210, 1);
    position: absolute;
    left: 20px;
    top: 150px;
    z-index: 2;
  }

  .vipbox-couline-f {
    height: 280px;
    border-left: 1px solid rgba(210, 210, 210, 1);
    position: absolute;
    left: 150px;
    top: 10px;
  }

  .vipbox-couline-s {
    height: 280px;
    border-left: 1px solid rgba(210, 210, 210, 1);
    position: absolute;
    left: 300px;
    top: 10px;
  }

  .billboard {
    height: 180px;
    border-radius: 4px;
    margin-top: 20px;
    background-color: #cccccc;
    cursor: pointer;
  }

  .billboard img {
    width: 1200px;
    height: 180px;
    cursor: pointer;
  }

  .industrynews {
    max-height: 575px;
    min-height: 143px;
    margin-top: -30px;
  }

  .industrynews-box {
    width: 100%;
    margin-top: 11px;
    /*height: 464px;*/
    max-height: 464px;
    min-height: 132px;
  }

  .industrynews-box ul {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    margin: 0;
    padding: 0;
  }

  .industrynews-box ul li {
    width: 592px;
    height: 132px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(229, 229, 229, 1);
    box-shadow: 0 2px 2px 0 rgba(49, 48, 48, 0.23);
    display: flex;
    flex-direction: row;
    margin-top: 19px;
    margin-left: 12px;
    cursor: pointer;
  }

  .leftimg {
    width: 130px;
    height: 132px;
    background-color: darkgray;
  }

  .leftimg img {
    width: 130px;
    height: 132px;
  }

  .rightcontent {
    width: calc(100% - 142px);
    text-align: left;
    margin-left: 12px;
    padding-right: 10px;
  }

  .rc-title {
    height: 15px;
    font-size: 16px;
    /*font-family:MicrosoftYaHei;*/
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 38px;
    position: relative;
  }

  .rc-title::after {
    content: "";
    position: absolute;
    left: 0;
    top: 32px;
    width: 22px;
    height: 3px;
    background: rgba(182, 11, 13, 1);
  }

  .rc-content {
    height: 34px;
    font-size: 16px;
    /*font-family:MicrosoftYaHei;*/
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 25px;
    margin-top: 25px;
  }

  .rc-time {
    height: 11px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    margin-top: 30px;
  }

  .partybuilding {
    height: 423px;
    display: flex;
    flex-direction: row;
  }

  .partybuilding-l {
    width: 809px;
    /*background-color: blue;*/
  }

  .partybuilding-bot {
    width: 100%;
  }

  .partybuilding-bot ul li {
    width: 100%;
    height: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px dashed rgba(220, 220, 220, 1);
    cursor: pointer;
  }

  .partybuilding-text {
    font-size: 16px;
    /*font-family:MicrosoftYaHei;*/
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .partybuilding-time {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(115, 115, 115, 1);
    line-height: 18px;
  }

  .partybuilding-r {
    width: calc(100% - 809px);
  }

  .partybuilding-swiper {
    width: 328px;
    height: 331px;
    background: rgba(245, 245, 245, 1);
    margin-left: 30px;
    margin-top: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-box {
    width: 214px;
    height: 276px;
  }

  .swiper-box .swiper-img {
    width: 214px;
    height: 276px;
  }

  .code {
    width: 214px;
  }

  .code img {
    width: 214px;
  }

  .comityservice {
    height: 250px;
    margin-top: 20px;
  }

  .comityservice-box ul {
    display: flex;
    flex-direction: row;
  }

  .comityservice-box-img {
    width: 116px;
    height: 116px;
    /*background:rgba(182,11,13,1);*/
    background: rgba(238, 238, 238, 1);
    border-radius: 50%;
    margin-top: 34px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    transition: all 0.3s;
  }

  .comityservice-box-img:hover {
    transform: scale(1.2);
    background: rgba(182, 11, 13, 1);
  }

  .comityservice-box-img-act {
    background: rgba(182, 11, 13, 1);
  }

  .comityservice-box-img img {
    margin-top: 0 !important;
  }

  .comityservice-box ul li {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }

  .comityservice-box ul li img {
    margin-top: 34px;
  }

  .comityservice-box ul li span {
    margin-top: 15px;
    font-size: 16px;
    /*font-family:MicrosoftYaHei;*/
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }

  .footer-swiper {
    height: 40px;
    margin-top: 40px;
    position: relative;
  }

  /*底部轮播*/
  .footer-swiper-box {
    overflow: hidden;
    width: 980px;
    /*background-color: rosybrown;*/
    height: 113px;
    margin-left: 107px;
    margin-top: 43px;
    /*position: relative;*/
  }

  .footer-swiper-box ul {
    width: 3000px;
    display: flex;
    flex-direction: row;
    margin-left: -31px;
    transition: all .3s;
    /*transform: translateX(-151*2px);*/
  }

  .footer-swiper-box ul li {
    width: 170px;
    height: 80px;
    line-height: 111px;
    margin-left: 31px;
    transition: all 0.3s;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    /*border: 1px solid #eaeaea;*/
  }

  .footer-swiper-box ul li img {
    width: 170px;
    height: 80px;
  }

  .arrow-left {
    width: 50px;
    height: 90px;
    background: rgba(83, 83, 83, 1);
    position: absolute;
    left: 0;
    top: 57px;
    background: url("../../assets/left_2.png");
    cursor: pointer;
  }

  .arrow-right {
    width: 50px;
    height: 90px;
    background: rgba(83, 83, 83, 1);
    position: absolute;
    right: 0;
    top: 57px;
    cursor: pointer;
    background: url("../../assets/right_2.png");
  }

  .hidden {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue